import { create } from 'zustand';
import { DEFAULT_STATE, fetchSetter } from '@growth/store-helpers';
import { _ as _asyncToGenerator, a as _regeneratorRuntime, g as getConfigStoreData } from '../../dist/xhr-d89d7e83.esm.js';
import { withBrowserStorageCaching } from '@growth/browser-caching';
import '@growth/api-calls';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var getConfigStoreDataClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
    var lobs, keys, cacheOpts, fetchOpts, initData, cacheKey, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lobs = opts.lobs, keys = opts.keys, cacheOpts = opts.cacheOpts, fetchOpts = opts.fetchOpts, initData = opts.initData;

            cacheKey = function cacheKey() {
              // merge the lob and keys to make a cachekey
              var l = typeof lobs === 'string' ? [lobs] : lobs;
              var k = typeof keys === 'string' ? [keys] : keys;
              var ckey = l.join('-') + "-" + k.join('-');
              return ckey.toLowerCase();
            };

            _context.next = 4;
            return withBrowserStorageCaching({
              key: cacheKey(),
              asyncMethod: function asyncMethod() {
                return getConfigStoreData({
                  lobs: lobs,
                  keys: keys,
                  fetchOpts: {
                    timeout: (fetchOpts == null ? void 0 : fetchOpts.timeout) || 2000
                  },
                  initData: initData
                });
              },
              ttl: (cacheOpts == null ? void 0 : cacheOpts.ttl) || 15
              /* minutes */
              ,
              ignoreCache: cacheOpts == null ? void 0 : cacheOpts.ignoreCache,
              revalidate: cacheOpts == null ? void 0 : cacheOpts.revalidate,
              type: 'indexDb'
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getConfigStoreDataClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

var createConfigStore = function createConfigStore() {
  return create()(function (set) {
    return _extends({}, DEFAULT_STATE, {
      fetch: function fetch(opts) {
        return fetchSetter({
          set: set,
          fetchFun: function fetchFun() {
            return getConfigStoreDataClient({
              lobs: opts.lobs,
              keys: opts.keys,
              cacheOpts: opts == null ? void 0 : opts.cacheOpts,
              initData: opts == null ? void 0 : opts.initData
            });
          },
          onSuccess: opts == null ? void 0 : opts.onSuccess
        });
      }
    });
  });
};

var setData = function setData(store, value) {
  return store.setState(function (s) {
    return {
      data: _extends({}, s.data, value),
      loaded: true
    };
  });
};

export { createConfigStore, getConfigStoreDataClient, setData };
